import { authSaga } from '../../modules/Auth/sagas'
import routerSaga from '../../Router/sagas'

export const legacySagas = [routerSaga, authSaga]
